import { useCallback, useState } from 'react';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { ApiService, TenantDomainWritable } from 'api';

const useSaveTenantMetadata = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErrors] = useState<string[] | null>(null);

  const saveTenantMetadata = useCallback(
    async ({
      url,
      firmId,
      enforcedSso,
      jitProvisioningEnabled,
      selectedFirmRole,
      domains,
    }: {
      url: string | null;
      firmId: number;
      enforcedSso: boolean;
      jitProvisioningEnabled: boolean;
      selectedFirmRole: number;
      domains: TenantDomainWritable[];
    }) => {
      try {
        await ApiService.apiSsoIntegrationsMetadataCreate({
          firm: firmId,
          metadata_url: url,
          enforced_sso: enforcedSso,
          jit_provisioning_enabled: jitProvisioningEnabled,
          default_firm_role: selectedFirmRole,
          domains,
        });
        enqueueSnackbar('Identity Provider Metadata URL saved successfully', { variant: 'success' });
        setErrors(null);
      } catch (error) {
        const axiosError = error as AxiosError<any>;
        enqueueSnackbar('Error saving Identity Provider Metadata URL', { variant: 'error' });
        if (axiosError.response!.data.metadata_url) {
          setErrors(axiosError.response!.data.metadata_url);
        }
        throw error;
      }
    },
    [enqueueSnackbar]
  );
  return { saveTenantMetadata, errors };
};

export default useSaveTenantMetadata;
